import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  getEnvironment(): 'Live' | 'Test' {
    return environment.storeEnvironment;
  }

  isLive(): boolean {
    return (environment.storeEnvironment as 'Live' | 'Test') === 'Live';
  }
}
